import { useEventCallback } from '../../../foundation';
import { UnmountSymbol } from '../PortalManager';
import { usePortalManagerWithID } from './usePortalManagerWithID';
export var useUnmountPortalHandler = function (handler) {
    var managerWithID = usePortalManagerWithID();
    var handleExited = useEventCallback(function (node) {
        handler === null || handler === void 0 ? void 0 : handler(node);
        if (managerWithID) {
            var manager = managerWithID.manager, id = managerWithID.id;
            manager[UnmountSymbol](id);
        }
    });
    return handleExited;
};
